import React from 'react';
import styled from 'styled-components';

export default ({ mainVideo, videoAlt }) => (
  <VideoContainer>
    <Video autoPlay loop preload style={{ width: '100vw' }}>
      <source src={mainVideo} type="video/mp4" />
    </Video>
    <Poster bg={videoAlt} />
  </VideoContainer>
);

const VideoContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  width: 100%;
  height: 100%;
  z-index: -100;
`;
const Video = styled.video`
  position: absolute;
  top: 50%;
  left: 50%;
  width: auto;
  height: auto;
  min-width: 120%;
  min-height: 120%;
  transform: translate(-50%, -50%);
  @media (max-width: 1200px) {
    display: none;
  }
`;

const Poster = styled.div`
  display: none;
  @media (max-width: 1200px) {
    display: block;
    width: 130vw;
    height: 130vh;
    position: absolute;
    left: -15vw;
    top: -15vh;
    background: url(${props => props.bg}) no-repeat center center;
    background-size: cover;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Title/components/video.js